import { useSelector } from "react-redux";
import { useCallback, useEffect } from "react";
import TransTable from "../../common/TransTable";
import _ from "lodash";
import { Box, Button, IconButton, Switch, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { setLoading, setPotSetting, setPotSettingList, setSelectedLeagues, setUsers, setWaitinglistpot } from "../../../redux/action";
import { Link, useNavigate } from "react-router-dom";
import Axios from "axios";
import { base_url } from "../../backendurl/url";
import { useState } from "react";
import UpdatePopup from "../../Leagues/UpdatePopup";
import { Config } from "../../../utils/commonFuctions/Token";
import { RefreshToken } from "../../../utils/commonFuctions/RefreshToken";
import { Notification } from "../../common/Notification";


export default function ActivePots() {
  const navigate = useNavigate();
  const {PotSettingList} = useSelector((state) => state);
  const [loading, setLoading] = useState(false)
  const [notification, setnotification] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
    // Server-side pagination states
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortOrder, setSortOrder] = useState('');
  const [sortBy, setSortBy] = useState('');
  const dispatch = useDispatch();
  const token = localStorage.getItem('token')

  const ActivePotList = () => [
    {
      key: "id",
      label: "Round ID",
      align: "left",
      fontSize: '15px',
      valueRenderer: (data) => {
        return (
          <Link
            component={Typography}
            style={{ color: "#3C50E0", textDecoration: "underline" }}
            to={`activeround/view/${data.id}`}
            onClick={() => dispatch(setWaitinglistpot(data))}
          >
            {data["id"]}
          </Link>
        );
      },
    },
    { key: "category", label: "Round Category", align: "left", fontSize: "15px" },
    { key: "league", label: "League", align: "left", fontSize: "15px" },
     {
      key: "min_round_value_display",
      label: "Min Round Value",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        // return `${data['pot_currency']}  ${data['min_pot_value']}`
        return `${data['min_round_value_display']}`
      }
    },
     {
      key: "max_round_value_display",
      label: "Max Round value",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        return `${data['max_round_value_display']}`
      }
    },
    { key: "round_value_display", label: "Round Value", align: "left", fontSize: "15px",
    valueRenderer: (data) => {
      // return `${data['pot_currency']}  ${data['current_pot_value']}`
      return `${data['round_value_display']}`
      }
     },
    { key: "admin_fee", label: "Admin Fee %", align: "left", fontSize: "15px",
   
   },
    {key: "joined_picks",label: "No. of Picks Joined",align: "center",fontSize: '14px',px : "10px"},
    { key: "start_match_week", label: "Start MW", align: "left", fontSize: "15px",
    valueRenderer: (data) => {
      // return `${data?.match_weeks?.start_match_week}`
      return `${data?.start_match_week}`

      }
   },
    { key: "current_match_week", label: "Current MW", align: "left", fontSize: "15px" ,
    valueRenderer: (data) => {
      // return `${data?.match_weeks?.current_match_week}`
      return `${data?.current_match_week}`
      }
  
  },
  {
      key: "deadline_voting",
      label: "Deadline Voting Count",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        return `${data['deadline_voting']}`
      }
    },
     {
      key: "tokens_per_pick",
      label: "Tokens Per Pick",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        return `${data['tokens_per_pick']}`
      }
    },
    {
      key: "picks_per_player",
      label: "Picks Per Player",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        return `${data['picks_per_player']}`
      }
    },
  ];
  const getActivePot = useCallback(async (page = 1, limit = 10, orderBy = '', order = '') => {
    setLoading(true)
    dispatch(setPotSettingList([]));
    try{
      let queryParams = `page=${page}&limit=${limit}&status=Active`;
      
      // Add sorting parameters if provided
      if (orderBy && order) {
        // queryParams += `&ordering=${order === 'desc' ? '-' : ''}${orderBy}`;
        queryParams += `&sort_by=${orderBy}&order=${order !== 'desc' ? 'desc' : 'asc'}`;

      }
      //console.log(`${base_url}/api/pot/rounds?${queryParams}`, "queryParamsActive")
      // if (PotSettingList.length === 0 && loading) {
        // const response = await Axios.get(`${base_url}/api/pot/pots?status=Active`, Config);
      const response = await Axios.get(`${base_url}/api/pot/rounds?${queryParams}`, Config);

        if (response?.status == 200) {
          dispatch(setPotSettingList(response?.data?.results));
           setTotalCount(response?.data?.count);
          setLoading(false)
          dispatch(setPotSetting({}))
        // }
      }
    }
    catch(error){
      RefreshToken(error,setErrorMessage,setnotification)
    }
   
  }, []);

    const handlePageChange = useCallback((page, rowsPerPage) => {
    setCurrentPage(page);
    setRowsPerPage(rowsPerPage);
    // API pages usually start from 1, but MUI pagination starts from 0
    getActivePot(page + 1, rowsPerPage, sortBy, sortOrder);
  }, [sortBy, sortOrder, getActivePot]);

  // Handle sorting change from TransTable
  const handleSortChange = useCallback((orderBy, order) => {
    setSortBy(orderBy);
    setSortOrder(order);
    // Reset to first page when sorting changes
    setCurrentPage(0);
    getActivePot(1, rowsPerPage, orderBy, order);
  }, [rowsPerPage, getActivePot]);


  const gotoAddUser = () => {
    navigate("add");
  };

  // useEffect(() => {
  //   getActivePot();
  // }, []);

  useEffect(() => {
    getActivePot(1, 10); // Initial load
  }, []);

  return (
    <>
      <Box  >
        <TransTable
          showSearch={false}
          checkbox={false}
          columns={ActivePotList()}
          rows={PotSettingList}
          addBtnAction={gotoAddUser}
          isLoading={loading}
           // Server-side pagination props
          serverSide={true}
          totalCount={totalCount}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onSortChange={handleSortChange}
        />
      <Notification message={errorMessage} setopen={setnotification} type={'error'} show={notification} />

      </Box>
    </>
  );
}
